import React, { useState } from 'react'
import { IconPencil } from '@tabler/icons-react'

import { Button } from '@/components/buttons/Button'
import { TextInput } from '@/components/forms/TextInput'

import './EditableHeader.scss'

export const EditableHeader = ({ initialName, updateName }) => {
  const [isEditMode, setIsEditMode] = useState(false)
  const [input, setInput] = useState(initialName)

  const handleUpdateName = () => {
    const nameChange = { name: input }

    updateName(null, nameChange)
    setIsEditMode(false)
  }

  return (
    <div className="editable-header-container flex-align-center" data-testid="editable-header">
      {!isEditMode ? (
        <>
          <div className="editable-header" data-testid="header-name">
            {initialName}
          </div>
          <Button
            basic
            small
            square
            onClick={() => setIsEditMode(true)}
            data-testid="edit-header-button"
          >
            <IconPencil />
          </Button>
        </>
      ) : (
        <div data-testid="editable-header-name" className="editable-header-container">
          <TextInput
            autoFocus
            type="text"
            value={input}
            onChange={(event) => setInput(event.target.value)}
          />
          <Button onClick={() => setIsEditMode(false)} data-testid="edit-header-button">
            Cancel
          </Button>
          <Button primary onClick={handleUpdateName} data-testid="save-name-button">
            Save
          </Button>
        </div>
      )}
    </div>
  )
}
